﻿import * as React from 'react';
import { NavLink } from "react-router-dom";

export default function AssetsLauncher() {
    return (
        <div id="assets-launcher-container" className="launcher-container">
            <h1 className="main-title">ASSETS LAUNCHER</h1>

            <div className="card-container">

                <NavLink className="pw-card-link" to="/assets">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">adf_scanner</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">ASSETS</div>
                            <div className="pw-home-card-text">Validation settings and scheduling</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/upcoming-calibrations">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">calendar_month</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div id="benchSheetsCard" className="pw-card-main-title">SCHEDULE</div>
                            <div className="pw-home-card-text">Upcoming validation event schedule</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/glassware">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">science</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">GLASSWARE</div>
                            <div className="pw-home-card-text">Glassware management</div>
                        </div>
                    </div>
                </NavLink>

                <NavLink className="pw-card-link" to="/columns">
                    <div className="pw-home-page-card">
                        <div className="pw-card-icon-section">
                            <span className="material-symbols-outlined home-card-icon">animation</span>
                        </div>

                        <div className="pw-card-data-section">
                            <div className="pw-card-main-title">COLUMNS</div>
                            <div className="pw-home-card-text">GC and HPLC column management</div>
                        </div>
                    </div>
                </NavLink>

            </div>
        </div>
    );
}